/** 명함 OCR 결과 필드와 UI 라벨 (고객관리 API 필드명과 동일) */
export const CRM_EXTRACT_FIELD_LABELS = {
  customerName: '이름',
  customerPhone: '전화번호',
  customerEmail: '이메일',
  birthDate: '생년월일',
  region: '지역',
  customerSegment: '고객 구분',
  affiliation: '소속',
  honorific: '호칭',
  homeAddress: '집 주소',
  companyAddress: '회사 주소',
  customerSource: '고객 출처',
}

function normStr(v) {
  if (v == null) return ''
  return String(v).trim()
}

function normPhone(v) {
  return normStr(v).replace(/\D/g, '')
}

/**
 * @param {Record<string, unknown>} current 고객 상세/폼의 현재 값
 * @param {Record<string, unknown>} extracted API `.../customers/extract-business-card-preview` 응답
 * @returns {{ key: string, label: string, before: string, after: string }[]}
 */
export function compareExtractedToCurrent(current, extracted) {
  if (!extracted || typeof extracted !== 'object') return []
  const cur = current && typeof current === 'object' ? current : {}
  const out = []
  for (const key of Object.keys(CRM_EXTRACT_FIELD_LABELS)) {
    const rawA = cur[key]
    const rawB = extracted[key]
    const a = key === 'customerPhone' ? normPhone(rawA) : normStr(rawA)
    const b = key === 'customerPhone' ? normPhone(rawB) : normStr(rawB)
    if (!b) continue
    if (a === b) continue
    out.push({
      key,
      label: CRM_EXTRACT_FIELD_LABELS[key],
      before: rawA != null ? String(rawA) : '',
      after: rawB != null ? String(rawB) : '',
    })
  }
  return out
}

/**
 * extract-preview 응답을 고객 등록(간편) 폼에 넣을 수 있는 값으로 정규화한다.
 * @param {Record<string, unknown>} extracted
 * @returns {Record<string, string>}
 */
export function patchCreateFormFromExtracted(extracted) {
  if (!extracted || typeof extracted !== 'object') return {}
  const pick = (k) => {
    const v = extracted[k]
    if (v == null) return ''
    return String(v).trim()
  }
  /** @type {Record<string, string>} */
  const out = {}
  const name = pick('customerName')
  if (name) out.customerName = name
  const ph = normPhone(extracted.customerPhone)
  if (ph.length === 10 || ph.length === 11) out.customerPhoneDigits = ph
  const bdRaw = pick('birthDate')
  if (bdRaw) {
    const d = bdRaw.replace(/\D/g, '').slice(0, 8)
    if (d.length === 8) out.birthDateDigits = d
  }
  const region = pick('region')
  if (region) out.region = region
  const seg = pick('customerSegment')
  if (seg) out.customerSegment = seg
  const aff = pick('affiliation')
  if (aff) out.affiliation = aff
  const hon = pick('honorific')
  if (hon) out.honorific = hon
  const home = pick('homeAddress')
  if (home) out.homeAddress = home
  const comp = pick('companyAddress')
  if (comp) out.companyAddress = comp
  const em = pick('customerEmail')
  if (em) out.customerEmail = em
  const src = pick('customerSource')
  if (src) out.customerSource = src
  return out
}
